import React from 'react';

interface DataGridProps {
  children: React.ReactNode;
  columns?: 2 | 3 | 4;
}

interface DataGridCardProps {
  children: React.ReactNode;
}

export const DataGrid: React.FC<DataGridProps> = ({ children, columns = 3 }) => {
  const colsClass = {
    2: 'grid-cols-2',
    3: 'grid-cols-3',
    4: 'grid-cols-4',
  };

  return <div className={`grid ${colsClass[columns]} gap-4`}>{children}</div>;
};

export const DataGridCard: React.FC<DataGridCardProps> = ({ children }) => {
  return (
    <div className="bg-white rounded-lg shadow-sm border border-gray-200 p-4 hover:shadow-md transition-shadow">
      <div className="flex flex-col gap-3">{children}</div>
    </div>
  );
};
